/* eslint-disable import/extensions */
import React from 'react';
import { usePathname } from 'next/navigation';
import { Button, } from 'react-bootstrap';
import { FaQuestion, } from 'react-icons/fa6';
import { help, } from '@/helpers/index';

export default function ToolbarProfileComponent() {
  const pathname = usePathname();

  return (
    <div className="btn-toolbar mb-2 mb-md-0">
      <Button type="button" variant="secondary" size="sm" className="shadow-sm ms-1" onClick={() => { help.show(pathname); }} title="Abrir barra de Ajuda">
        <FaQuestion />
        Ajuda
      </Button>
    </div>
  );
}
